<script>
  import Modal from "./../../../shared/Modal.svelte";
  import config from "./../../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import { fade } from "svelte/transition";
  import * as ls from "local-storage";
  import loadData from "../../../utils/loadData";

  export let EDITABLE = false;

  const dispatch = createEventDispatcher();
  const authData = { headers: { authorization: ls.get("jwt") } };

  export let styleID;
  export let itemID;
  export let _id;
  export let qtyReq;
  export let qtyUsed;
  export let uPrice;

  let derivedName = $config?.items?.find(({ value }) => value == itemID)?.label;
  let inventoryLevel = $config?.items?.find(
    ({ value }) => value == itemID
  )?.inventoryLevel;
  let plankNumber = $config?.items?.find(
    ({ value }) => value == itemID
  )?.plankNumber;

  let editedMat = {
    itemID,
    qtyReq,
    qtyUsed,
    uPrice,
  };

  let showEditMatForm = false;
  let editMatLoading = false;

  const handleEditStyle = async (e) => {
    if (editedMat.qtyReq == undefined) alert("⚠ Qty Needed missing!");
    else {
      editMatLoading = true;

      let data = { ...editedMat };

      axios
        .put(
          `${$config.backendURL}/fstyles/${styleID}/edit-material/${_id}`,
          data,
          authData
        )
        .then((res) => {
          showEditMatForm = false;
          editMatLoading = false;
          setTimeout(() => {
            dispatch("update");
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleDelete = () => {
    let confirmDelete = confirm(`Do you wish to delete ${derivedName}?`);

    if (confirmDelete) {
      axios
        .delete(
          `${$config.backendURL}/fstyles/${styleID}/delete-material/${_id}`,
          authData
        )
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  const handleDecrement = () => {
    let qty = prompt(`Enter the quantity to add to stock. Example. 20`);

    qty = qty?.replaceAll(/[^\d.-]/g, "");
    qty = Number?.parseFloat(qty?.replaceAll("-", ""));

    if (inventoryLevel < qty) {
      alert(
        `\n⚠ There's not enough of ${derivedName} in Stock to assign the requested quantity.`
      );
      return;
    }

    if (qty > qtyReq - qtyUsed) {
      alert(
        `\n⚠ You cannot take from stock a quantity beyond what is requested for this material.`
      );
      return;
    }

    axios
      .put(
        `${$config.backendURL}/fstyles/decrement/${itemID}/${styleID}/${_id}`,
        { qty },
        {
          headers: { authorization: ls.get("jwt") },
        }
      )
      .then((res) => {
        loadData();
        dispatch("delete");
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  };
</script>

<div
  in:fade={{ duration: $config.f.time() }}
  class="tr border-b border-gray-100"
>
  {#if EDITABLE}
    <div style="min-width: 10rem; max-width: 10rem;" class="flex items-center">
      <button
        class="text-base btn btn-red-outline mr-2"
        on:click={handleDelete}
      >
        <i class="fas fa-trash" />
      </button>
      <button
        class="text-base btn btn-primary-outline mr-2"
        on:click={(e) => (showEditMatForm = true)}
      >
        <i class="fas fa-edit" />
      </button>
      {#if qtyUsed >= qtyReq}
        <button
          class="text-base btn btn-green-outline mr-2 opacity-50 cursor-not-allowed"
        >
          <i class="fas fa-check-circle" />
        </button>
      {:else}
        <button
          class="text-base btn btn-green-outline mr-2"
          on:click={handleDecrement}
        >
          <i class="fas fa-plus-circle" />
        </button>
      {/if}
    </div>
  {/if}
  <div style="min-width: 15rem; max-width: 15rem;">{derivedName}</div>
  <div style="min-width: 7rem; max-width: 7rem;">
    {plankNumber || ""}
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">{qtyReq}</div>

  {#if EDITABLE}
    <div style="min-width: 7rem; max-width: 7rem;" class="text-red-400">
      {inventoryLevel}
    </div>
    <div style="min-width: 7rem; max-width: 7rem;">{qtyUsed}</div>
    <div style="min-width: 7rem; max-width: 7rem;">{qtyReq - qtyUsed}</div>
  {/if}

  <div style="min-width: 7rem; max-width: 7rem;">R{uPrice}</div>
  <div style="min-width: 7rem; max-width: 7rem;">
    R{(uPrice * qtyReq).toFixed(2)}
  </div>
</div>

<!-- EDIT MODAL -->
<Modal
  show={showEditMatForm}
  on:modalClose={() => {
    showEditMatForm = false;
  }}
>
  <div class="grid gap-y-2">
    <div class="flex items-center uppercase">
      <i class="text-brand fas fa-exclamation-circle text-xl mr-2" />
      <div class="col-span-2 text-base">
        {derivedName}
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Required :</div>
      <input
        class="col-span-2"
        bind:value={editedMat.qtyReq}
        type="number"
        step="any"
        placeholder="Quantity required"
      />
    </div>

    {#if editMatLoading}
      <div class="flex items-center justify-center btn btn-primary-outline">
        <Wave size="25" color="rgb(244,162,97)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-primary"
          on:click={handleEditStyle}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showEditMatForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

<!-- EDIT MODAL -->
<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
